import { useNavigate } from 'react-router-dom';
import { usePageTitle } from './hooks/usePageTitle';

export default function NotFound() {
  const navigate = useNavigate();

  usePageTitle('404 - Page Not Found');

  return (
    <div className="flex flex-col items-center justify-center gap-6 py-12">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-light-main mb-4">404</h1>
        <h2 className="text-3xl font-semibold text-light-text mb-2">
          Page Not Found
        </h2>
        <p className="text-lg text-gray-600 mb-8">
          Sorry, the page you're looking for doesn't exist or has been moved.
        </p>
      </div>
      
      <button
        onClick={() => navigate('/')}
        className="px-6 py-3 bg-light-main text-white rounded-md hover:bg-light-main-hover transition-colors duration-200 ease-in-out font-medium"
      >
        Return to Home
      </button>
    </div>
  );
}
